import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Edit2, Trash2 } from "lucide-react";

export default function AdminAnnouncements() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ title: "", body: "", priority: "normal", date: "" });
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/announcements").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const save = async (e) => {
    e.preventDefault();
    if (editing) await api.put(`/announcements/${editing}`, form);
    else await api.post("/announcements", form);
    toast.success("Salvo");
    setForm({ title: "", body: "", priority: "normal", date: "" });
    setEditing(null); load();
  };
  const del = async (id) => { if (!confirm("Excluir?")) return; await api.delete(`/announcements/${id}`); toast.success("Excluído"); load(); };
  return (
    <div className="space-y-6">
      <div><div className="label">Novidades</div><h1 className="font-display text-3xl sm:text-4xl font-black mt-2">Avisos</h1></div>
      <form onSubmit={save} className="ci-card p-6 space-y-4" data-testid="admin-announcement-form">
        <div><label className="label">Título</label><input required value={form.title} onChange={(e)=>setForm({...form, title:e.target.value})} className="ci-input mt-1"/></div>
        <div><label className="label">Conteúdo</label><textarea rows={4} required value={form.body} onChange={(e)=>setForm({...form, body:e.target.value})} className="ci-input mt-1 resize-none"/></div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><label className="label">Prioridade</label>
            <select value={form.priority} onChange={(e)=>setForm({...form, priority:e.target.value})} className="ci-input mt-1">
              <option value="normal">Normal</option><option value="important">Importante</option>
            </select>
          </div>
          <div><label className="label">Data</label><input type="date" value={form.date?.slice(0,10) || ""} onChange={(e)=>setForm({...form, date:e.target.value})} className="ci-input mt-1"/></div>
        </div>
        <div className="flex gap-3">
          <button type="submit" className="btn-primary"><Plus size={16}/> {editing ? "Atualizar" : "Publicar"}</button>
          {editing && <button type="button" onClick={()=>{setEditing(null); setForm({title:"", body:"", priority:"normal", date:""});}} className="btn-ghost">Cancelar</button>}
        </div>
      </form>
      <div className="grid gap-3 md:grid-cols-2">
        {list.map((a) => (
          <div key={a.id} className="ci-card p-5">
            <div className="flex items-center justify-between">
              <span className="text-xs text-slate-500">{new Date(a.date).toLocaleDateString("pt-BR")}</span>
              {a.priority === "important" && <span className="text-[10px] font-bold text-blue-300 bg-blue-500/10 border border-blue-500/30 px-2 py-0.5 rounded-full">IMPORTANTE</span>}
            </div>
            <h3 className="font-display text-lg font-bold mt-2">{a.title}</h3>
            <p className="text-sm text-slate-400 mt-1 line-clamp-3">{a.body}</p>
            <div className="mt-3 flex gap-2">
              <button onClick={()=>{setForm({...a}); setEditing(a.id);}} className="btn-ghost text-xs py-1.5 px-3"><Edit2 size={12}/></button>
              <button onClick={()=>del(a.id)} className="btn-ghost text-xs py-1.5 px-3 border-red-500/30 text-red-300"><Trash2 size={12}/></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
